import cn from 'classnames';
import { Badge, Card, Carousel, CustomModal, Typography, useOverlayContext } from 'seagull';
import { ArrowDownFill } from 'seagull/icons';
import { useIoContext, useStoreActions } from "../../../../../contexts";
import { useTutorialVideos } from "../../../../../hooks/useTutorialVideos/useTutorialVideos";
import styles from "./TutorialVideos.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const TutorialVideo = _ref => {
  let {
    video,
    onWatch,
    className,
    youtubePlayerWidth,
    youtubePlayerHeight
  } = _ref;
  const {
    id,
    title,
    watched,
    duration
  } = video;
  const {
    logBI
  } = useStoreActions();
  const overlayContext = useOverlayContext();
  const {
    YoutubePlayer
  } = useIoContext();
  const openModal = async () => {
    if (!watched) await onWatch(video);
    overlayContext.showModal({
      content: _ref2 => {
        let {
          dismissModal
        } = _ref2;
        const handleDismiss = () => {
          logBI(11216, {
            title
          });
          dismissModal();
        };
        return /*#__PURE__*/_jsx(CustomModal, {
          onClose: handleDismiss,
          "data-testid": "video-modal",
          hideCloseBtn: true,
          children: /*#__PURE__*/_jsx(YoutubePlayer, {
            playing: true,
            controls: true,
            url: "https://youtu.be/".concat(id),
            onStart: () => logBI(11215, {
              title
            }),
            onEnded: handleDismiss
          })
        });
      },
      closeOnEscapeKey: true,
      closeOnClickOutside: true
    });
  };
  return /*#__PURE__*/_jsxs(Card, {
    className: cn(styles.container, className),
    "data-testid": "tutorial-video",
    as: "button",
    onClick: openModal,
    children: [/*#__PURE__*/_jsx(YoutubePlayer, {
      className: styles.thumbnail,
      playIcon: /*#__PURE__*/_jsx(ArrowDownFill, {
        className: styles.playIcon
      }),
      light: true,
      height: youtubePlayerHeight,
      width: youtubePlayerWidth,
      url: "https://youtu.be/".concat(id)
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.description,
      children: [/*#__PURE__*/_jsx(Typography, {
        className: styles.title,
        weight: "bold",
        ellipsis: true,
        children: title
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.durationRow,
        children: [/*#__PURE__*/_jsx(Typography, {
          children: "".concat(duration, " min")
        }), watched && /*#__PURE__*/_jsx(Badge, {
          rounded: true,
          outlined: true,
          skin: "success",
          "data-testid": "tutorial-video-watched-tag",
          children: "Watched"
        })]
      })]
    })]
  });
};
export default function TutorialVideos() {
  const {
    videos,
    handleWatch
  } = useTutorialVideos();
  return /*#__PURE__*/_jsx(Carousel, {
    children: videos.map(video => /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(TutorialVideo, {
        className: styles.playerContainer,
        video: video,
        onWatch: handleWatch,
        youtubePlayerWidth: 232,
        youtubePlayerHeight: 131
      })
    }, video.id))
  });
}